import { StyleSheet } from 'react-native'
import type { VictoryLabelStyleObject, VictoryStyleObject } from 'victory'
import Color from 'color'
import { Colors, Metrics } from 'APP/Themes'
import { getColourScheme, ColourScheme } from 'APP/Helpers/AppearanceUtils'

// FIXME: Just. why
const chartBlurredColor =
  getColourScheme() === ColourScheme.DARK ? Colors.text : Color(Colors.accent).lighten(0.5).hex()

const nativeStyles = StyleSheet.create({
  chartContainer: {
    marginLeft: -Metrics.baseMargin,
  },
})

export default {
  chartContainer: nativeStyles.chartContainer,
  populationAverageLine: {
    stroke: Colors.buttonSecondaryDisabled,
    strokeWidth: 1,
    strokeDasharray: '3, 3',
  } satisfies VictoryStyleObject,
  populationAverageCopy: {
    fill: Colors.buttonSecondaryDisabled,
    fontSize: 12,
  } satisfies VictoryLabelStyleObject,
  line: {
    stroke: Colors.accent,
    strokeWidth: 3,
    clipPath: 'url(#activeClip)',
  } satisfies VictoryStyleObject,
  blurredLine: {
    stroke: chartBlurredColor,
    strokeWidth: 3,
    clipPath: 'url(#baseClip)',
  } satisfies VictoryStyleObject,
  scatterDots: {
    fill: ({ datum }) => (datum.blured ? chartBlurredColor : Colors.accent),
    stroke: ({ datum }) => (datum.active ? Colors.accent : Colors.appBg),
    strokeOpacity: ({ datum }) => (datum.active ? 0.2 : 1),
    strokeWidth: ({ datum }) => (datum.active ? 20 : 1),
  } satisfies VictoryStyleObject,
}
